import { useContext } from "react";

import PropTypes from "prop-types";

import { useTranslation } from "components/i18n/source";
import { PropertyListingContext, useBootstrap } from "components/store/source";
import { Header, Section } from "components/ui/source";

import AmenitiesList from "./AmenitiesList";
import BuildingCarousel from "./BuildingCarousel";
import UpgradesList from "./UpgradesList/UpgradesList";

import styles from "./Building.module.scss";

function Building({ id, className }) {
  const { t } = useTranslation();
  const { listing, availableUpgrades } = useContext(PropertyListingContext);
  const {
    featureFlags: { ancillariesAsUpgrades },
  } = useBootstrap();

  return (
    <Section id={id} className={className}>
      <Header size="md" type="headline3">
        {t("listing:building.title", {
          buildingName: listing.title,
        })}
      </Header>

      <BuildingCarousel
        className={styles.building_carousel}
        listingId={listing?.id}
        photos={listing?.buildingPhotos}
      />
      <AmenitiesList
        className={styles.amenities_list}
        amenities={listing?.amenities}
      />
      {ancillariesAsUpgrades && (
        <UpgradesList
          className={styles.amenities_list}
          upgrades={availableUpgrades}
        />
      )}
    </Section>
  );
}

Building.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
};

export default Building;
